module.exports = __webpack_public_path__ + "img/download-on-app-store.cfac7ec3.png";